import BareInput, { BareInputProps } from "./BareInput";
import InputFormField, { InputFormFieldExtraProps } from "./InputFormField";

export type InputProps =
  | (BareInputProps & { withForm?: false; name: never })
  | (BareInputProps &
      InputFormFieldExtraProps & { withForm: true; name: string });

const Input = (props: InputProps) => {
  if (props.withForm) {
    return <InputFormField {...props} />;
  }

  return <BareInput {...props} />;
};

Input.displayName = "Input";

export default Input;
export { BareInput };
export type { BareInputProps, InputFormFieldExtraProps };
